import { render, staticRenderFns } from "./lv-column-item.vue?vue&type=template&id=1e6048b6&"
import script from "./lv-column-item.vue?vue&type=script&lang=js&"
export * from "./lv-column-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports